// extracted by mini-css-extract-plugin
export default {"signupWrapper":"styles_signupWrapper__J0o4W"};